import React from 'react';
import PropTypes from 'prop-types';
import { BENCH_POSITIONS, MAT_SPOTS, PRIZE_POSITIONS } from './layout';
import { Half, Mat, MatPhoto, Spot } from './styled';

const at = ([left, top]) => ({ left: `${left}%`, top: `${top}%` });

/**
 * One player's spots on their half of the mat, each filled by `spot(zone, position)`: what's in that spot, or
 * nothing. The game fills them with the cards you play with (MatBoard); the games list with pictures of them
 * (Games/MiniBoard), so both look the same.
 */
export const MatHalf = ({ opponent, spot }) => (
  <Half $opponent={opponent} data-side={opponent ? 'opponent' : 'player'}>
    {PRIZE_POSITIONS.map(position => (
      <Spot key={`prize-${position}`} style={at(MAT_SPOTS.prizes[position])} data-zone="prize">
        {spot('prize', position)}
      </Spot>
    ))}
    <Spot style={at(opponent ? MAT_SPOTS.opponentActive : MAT_SPOTS.active)} data-zone="active">{spot('active')}</Spot>
    {BENCH_POSITIONS.map(position => (
      <Spot key={`bench-${position}`} style={at(MAT_SPOTS.bench[position])} data-zone="bench">
        {spot('bench', position)}
      </Spot>
    ))}
    <Spot style={at(MAT_SPOTS.deck)} data-zone="deck">{spot('deck')}</Spot>
    <Spot style={at(MAT_SPOTS.discard)} data-zone="discard">{spot('discard')}</Spot>
  </Half>
);

MatHalf.propTypes = {
  opponent: PropTypes.bool,
  /** (zone, position) => node, for zones 'prize', 'active', 'bench', 'deck' and 'discard' */
  spot: PropTypes.func.isRequired,
};

/**
 * The original playmat photo with both halves: yours at the bottom, the opponent's turned to face them, the way it
 * would be across a table. `turned` turns the photo for the second player, whose half is its printed top.
 */
const MatLayout = ({ turned, opponentSpot, playerSpot }) => (
  <Mat>
    <MatPhoto $turned={turned} />
    <MatHalf opponent spot={opponentSpot} />
    <MatHalf spot={playerSpot} />
  </Mat>
);

MatLayout.propTypes = {
  turned: PropTypes.bool,
  opponentSpot: PropTypes.func.isRequired,
  playerSpot: PropTypes.func.isRequired,
};

export default MatLayout;
